export enum CalendarView {
  Year = 0,
  Month = 1,
  Day = 3,
}

export type Year = {
  readonly value: Date;
  readonly formatted: string;
  readonly isDisabled?: boolean;
};

export type Month = {
  readonly value: string;
  readonly formatted: string;
  readonly isDisabled?: boolean;
};

export type SideBySideView = boolean | { readonly numberOfVisibleItems: number };
